import React, { useState } from 'react';
import { Button, Modal, ModalBody, ModalHeader, ModalFooter, Form, } from 'reactstrap';
import { isEmpty, mapValues, } from 'lodash';
import { toast } from 'react-toastify';

import useFormState from '../hooks/useFormState';
import Field from '../Field';
import { functions } from '../../firebase';

const findEmailByPhoneAndName = functions.httpsCallable('findEmailByPhoneAndName');
const { entries } = Object;
const fields = {
  phone: {
    type: 'string',
    label: '電話番号',
    placeholder: '08012345678 （ハイフンなし）',
    validations: {
      required: v => !isEmpty(v),
    },
  },
  displayName: {
    type: 'string',
    label: 'お名前',
    validations: {
      required: v => !isEmpty(v),
    },
  },
};

export default function EmailRecoveryFormModal(props) {
  const { isOpen, onClickClose } = props;
  const [maskedEmail, setMaskedEmail] = useState(null);
  const statedFields = useFormState(null, fields, isOpen);
  const isUnsubmittable = Object.values(statedFields).some(_ => !_.isValid);
  const onSubmit = async (event) => {
    event.preventDefault();
    if(isUnsubmittable) return;
    try {
      const { data } = await findEmailByPhoneAndName({ ...mapValues(statedFields, 'value') });
      setMaskedEmail(data.maskedEmail);
    } catch(e) {
      console.error(e);
      // callable のエラーコードは functions/ プレフィックスが付く
      const code = (e.code || '').replace(/^functions\//, '');
      const message = ({
        'invalid-argument': '電話番号とお名前を入力してください',
        'not-found': 'ご登録の情報が見つかりませんでした。入力内容をご確認ください。',
      })[code] || 'エラーが発生しました。';
      toast.error(message);
    }
  };

  return (
    <Modal isOpen={isOpen}>
      <ModalHeader>
        メールアドレスの確認
      </ModalHeader>
      {
        maskedEmail != null ? (
          <>
            <ModalBody>
              <div>ご登録のメールアドレスは次のとおりです。</div>
              <div className="h4 my-3 text-center">{maskedEmail}</div>
              <div className="text-muted small">
                セキュリティのため一部を伏せています。お心当たりのメールアドレスでログインをお試しください。
              </div>
            </ModalBody>
            <ModalFooter>
              <Button color="primary" onClick={onClickClose}>閉じる</Button>
            </ModalFooter>
          </>
        ) : (
          <Form onSubmit={onSubmit}>
            <ModalBody>
              <div className="text-muted small mb-3">
                ご登録の電話番号とお名前を入力してください。メールアドレスの一部をお伝えします。
              </div>
              {
                entries(statedFields).map(([fieldName, fieldSetting]) => (
                  <Field
                    key={fieldName}
                    name={fieldName}
                    {...fieldSetting}
                  />
                ))
              }
            </ModalBody>
            <ModalFooter>
              <Button className="cancel" color="secondary" onClick={onClickClose}>閉じる</Button>
              <Button className="save" type="submit" color="primary" onClick={onSubmit} disabled={isUnsubmittable}>確認する</Button>
            </ModalFooter>
          </Form>
        )
      }
    </Modal>
  );
};
